import { connect } from "react-redux";
import ToggleBarComponent from "components/ToggleBar";
import { persistTogglesAction } from "data/actions";
import immutable from "object-path-immutable";

// apply Redux Store state to Component Properties
export const mapStateToProps = (state, ownProps) => {
    //console.log('mapStateToProps', state, ownProps);
    let toggleState = state.toggles[ownProps.name];
    if (toggleState != null) {
        let result = {
            name: ownProps.name,
            isMultiple:
                state.browser.greaterThanOrEqual.medium && ownProps.isMultiple,
        };

        result.toggles = ownProps.toggles.map((toggle) => {
            return immutable(toggle)
                .set(
                    "isSelected",
                    toggleState._selected
                        ? toggleState._selected.includes(toggle.value)
                        : false
                )
                .set(
                    "count",
                    toggleState.counts &&
                        (toggleState.counts[toggle.value] || 0)
                )
                .set(
                    "status",
                    toggleState.status &&
                        (toggleState.status[toggle.value] || null)
                )
                .value();
        });
        return result;
    }

    const { isMultiple, ...otherProps } = ownProps;

    return {
        isMultiple: state.browser.greaterThanOrEqual.medium && isMultiple,
        ...otherProps,
    };
};

// create the Component giving parent Properties and handling the onClick event to dispatch changes to the Store
//export const mapDispatchToProps = (dispatch, ownProps) => {
export const mergeProps = (stateProps, dispatchProps, ownProps) => {
    // if NOT isMultiple and multiple selected leave only the first one
    if (
        !stateProps.isMultiple &&
        stateProps.toggles.filter((toggle) => {
            return toggle.isSelected;
        }).length > 1
    ) {
        const newtoggles = stateProps.toggles.map(
            (toggle: ToggleItemDTO, index: number) => {
                return immutable(toggle)
                    .set("isSelected", index === 0)
                    .value();
            }
        );
        dispatchProps.dispatch(
            persistTogglesAction(stateProps.name, newtoggles)
        );
    }

    return {
        ...stateProps,
        ...dispatchProps,
        onClick: (item, isMultiple) => {
            var toggles = stateProps.toggles.map((toggle) => {
                if (!isMultiple) toggle.isSelected = false;
                if (toggle.value === item.value) {
                    toggle.isSelected = !toggle.isSelected;
                }
                return toggle;
            }, this);
            // if none selected preselect first one
            /* istanbul ignore else */
            if (
                toggles.filter((toggle) => {
                    return toggle.isSelected;
                }).length === 0
            ) {
                toggles[0].isSelected = true;
            }
            dispatchProps.dispatch(
                persistTogglesAction(ownProps.name, toggles)
            );
        },
    };
};

const ToggleBarContainer = connect(
    mapStateToProps,
    null,
    mergeProps
)(ToggleBarComponent);

export default ToggleBarContainer;
